import QlikWebSocketService from 'websockets/service/QlikWebSocketService';
import QlikSaaSManager from 'websockets/manager/QlikSaaSManager';

class QlikSaaSService extends QlikWebSocketService {
    constructor() {
        super();
        if (QlikSaaSService.instance) {
            return QlikSaaSService.instance;
        }
        QlikSaaSService.instance = this;
        return QlikSaaSService.instance;
    }

    async createSocket(config) {
        console.info('create socket ', config.appId);
        const newSocket = new QlikSaaSManager();
        if (newSocket.socketIsReady) {
            try {
                await newSocket.initSocket(config);
                this._addSocket(newSocket);
            } catch (error) {
                console.error('Failed to create new socket', error);
            }
        }
        return newSocket;
    }

}
export default QlikSaaSService;
